﻿interface BitrixResponse<T> {
	status: 'success' | 'error';
	data: T;
	errors: Array<{
		message: string;
		code: string;
	}>;
}

async function fetchQuizSteps(url: string): Promise<QuizData> {
	const response = await fetch(url, { method: 'POST' });
	if (!response.ok) throw new Error('Failed to fetch quiz steps');
	
	const json: BitrixResponse<QuizData> = await response.json();

	if (json.status !== 'success') {
		const errorMsg = json.errors?.[0]?.message || 'Bitrix execution error';
		throw new Error(errorMsg);
	}

	return json.data;
}

async function fetchQuizResults(url: string, answers: QuizAnswers): Promise<QuizResult[]> {
	const response = await fetch(url + '/result', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(answers),
	});

	if (!response.ok) throw new Error('Failed to fetch quiz results');

	const json: BitrixResponse<QuizResult[]> = await response.json();

	if (json.status !== 'success') {
		const errorMsg = json.errors?.[0]?.message || 'Bitrix execution error';
		throw new Error(errorMsg);
	}

	return json.data;
}

export { fetchQuizSteps, fetchQuizResults };